import Vue from 'vue'
import Router from 'vue-router'

import Navigation from '@/components/navigation'
import Home from '@/components/home2'
import News from '@/components/news'
import productDisplay from '@/components/productDisplay'
import pd_home from '@/components/pd_home'
import pd_v1 from '@/components/pd_v1'
import pd_v2 from '@/components/pd_v2'
import pd_v3 from '@/components/pd_v3'
import pd_v4 from '@/components/pd_v4'


import mainAboutUs from '@/components/aboutUs'
import us_intro from '@/components/us_intro'
import us_culture from '@/components/us_culture'
import us_environment from '@/components/us_environment'
import recruitment from  '@/components/recruitment'

Vue.use(Router)



const router = new Router( {
  // mode : 'history',
  // base: '/HTZS/',  //添加的地方
  routes: [
    {
      path: '/',
      name: 'Navigation',
      component: Navigation,
      children: [
        //首页
        {
          path: "/",
          name: "Home",
          component: Home
        },//关于公司
        {
          path: "/mainAboutUs",
          name: "mainAboutUs",
          component: mainAboutUs,
          children: [
            {//简介
              path: "/",
              name: "us_intro",
              component: us_intro
            },
            // {//文化
            //   path: "/us_culture",
            //   name: "us_culture",
            //   component: us_culture
            // },
            {//风貌
              path: "/us_environment",
              name: "us_environment",
              component: us_environment
            },
          ]
        },
        //产品展示
        {
          path: "/productDisplay",
          name: "productDisplay",
          component: productDisplay,
          children: [
            {//产品首页
              path: "/",
              name: "pd_home",
              component: pd_home
            },
            {//产品一
              path: "/pd_v1",
              name: "pd_v1",
              component: pd_v1
            },
            {//产品二
              path: "/pd_v2",
              name: "pd_v2",
              component: pd_v2
            },
            {//产品三
              path: "/pd_v3",
              name: "pd_v3",
              component: pd_v3
            },
            {//产品四
              path: "/pd_v4",
              name: "pd_v4",
              component: pd_v4
            },
          ]
        },
        //新闻动态
        // {
        //   path: "/News",
        //   name: "News",
        //   component: News
        // },
        //招贤纳士
        {
          path: "/recruitment",
          name: "recruitment",
          component: recruitment
        },
      ]
    }
  ]
})

router.afterEach((to,from,next) => {
  window.scrollTo(0,0);
})
// 路由守卫
// router.beforeEach((to, from, next) => {
//   next()
// });

export default router




// WEBPACK FOOTER //
// ./src/router/index.js